<template>
  <div v-if="isExObituaryMember" class="member-info__wraps">
    <h4 class="member-info__title">상주</h4>

    <div class="divider"></div>
    <div class="member-info__contents">
      <div
        v-for="(obituaryMember, idx) in obituaryMembers"
        :key="idx"
        class="members__wrap"
      >
        <span class="member-type">{{ obituaryMember.type }}</span>

        <div class="member-name__wrap">
          <span
            v-for="(name, i) in obituaryMember.value[0].split(', ')"
            :key="i"
            :class="{
              'empty-name': name.includes('빈빈빈') || name.includes('빈빈')
            }"
            style="display: flex; gap: 5px;"
          >
            {{
              obituaryMember.value[0].split(", ").length - 1 === i
                ? name
                : `${name}`
            }}
            <a v-if="obituaryMember.phoneYn && obituaryMember.value[1] !== null && obituaryMember.value[1].split(', ')[i] !== 'null' && 
            obituaryMember.value[1] !== '' && obituaryMember.value[1].split(', ')[i] !== ''"
            :href="`tel:${obituaryMember.value[1].split(', ')[i]}`" style="display: flex; align-items: center;"><img src="@/assets/images/obituary/phone-circle.svg" alt="phone" style="width: 20px; cursor: pointer;"/></a>
            {{
              obituaryMember.value[0].split(", ").length - 1 === i
                ? ``
                : `,`
            }}
          </span>
        </div>
      </div>
    </div>

    <div class="divider"></div>
  </div>
</template>

<script>
export default {
  name: "ObituaryMemberInfo",
  props: ["obituaryMembers"],

  data() {
    return {
      memberId: this.$route.query.memberId ? this.$route.query.memberId : null
    };
  },

  computed: {
    isExObituaryMember() {
      //console.log(this.obituaryMembers)
      return this.obituaryMembers?.length > 0;
    },

    //FIXME : 고쳐야함
    currentMember() {
      if (this.isExObituaryMember) {
        return this.obituaryMembers?.find(v => v.id === +this.memberId);
      } else {
        return null;
      }
    }
  }
};
</script>

<style></style>
